var $3fc6e6880cad247e$exports = {};
$3fc6e6880cad247e$exports = {
    "dismiss": `Luk`
};


export {$3fc6e6880cad247e$exports as default};
//# sourceMappingURL=da-DK.mjs.map
